import React from 'react'

const Error = () => {
  return (
    <div className='flex justify-center items-center text-3xl text-richblack-300'>
      Error - 404 Not Found
    </div>
  )
}

export default Error
